<!--
  AvatarStack.vue

  Overlapping avatar stack with a "+N" overflow pill. Used in the Stores
  list Owner column when multiple accounts are attached to a campaign.

  Expects `people` as an array of:
    { name?: string, initials?: string, kind?: 'owner' | 'builder' }
  Empty/missing array renders nothing (caller can render an em-dash).
-->
<template>
    <div
        v-if="visible.length"
        class="dist-avatar-stack"
        :data-testid="`dist-avatar-stack-${visible.length}`"
    >
        <Avatar
            v-for="(p, i) in visible"
            :key="p.id || p.name || i"
            :name="p.name"
            :initials="p.initials"
            :kind="p.kind || 'builder'"
            class="dist-avatar-stack__item"
        />
        <span
            v-if="overflowCount > 0"
            class="dist-avatar-stack__overflow"
            :title="overflowTitle"
            data-testid="dist-avatar-stack-overflow"
        >
            +{{ overflowCount }}
        </span>
    </div>
</template>

<script>
import Avatar from "./Avatar.vue";

export default {
    name: "AvatarStack",
    components: { Avatar },
    props: {
        people: { type: Array, default: () => [] },
        max: { type: Number, default: 3 },
    },
    computed: {
        visible() {
            return this.people.slice(0, this.max);
        },
        overflowCount() {
            return Math.max(0, this.people.length - this.max);
        },
        overflowTitle() {
            return this.people
                .slice(this.max)
                .map((p) => p.name || p.initials || "?")
                .join(", ");
        },
    },
};
</script>

<style scoped>
.dist-avatar-stack {
    display: inline-flex;
    align-items: center;
}
.dist-avatar-stack__item {
    margin-left: -8px;
    border: 2px solid var(--tf-bg);
    box-sizing: content-box;
}
.dist-avatar-stack__item:first-child {
    margin-left: 0;
}
.dist-avatar-stack__overflow {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 26px;
    height: 26px;
    margin-left: 4px;
    padding: 0 6px;
    border-radius: 9999px;
    background: #eef0f3;
    color: var(--tf-fg-2);
    font-size: 10px;
    font-weight: 600;
    font-family: "Poppins", sans-serif;
    user-select: none;
}
</style>
